import styled from 'styled-components';

// Form de cadastro/edicao de variavel — alinhado ao design system CCO
// (tokens var(--cco-*)) em vez do tema legado (props.theme.colors.*).

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 107px);
  min-height: calc(100vh - 40px);
  margin: 15px 0 25px 107px;
  padding-right: 1%;
  box-sizing: border-box;
  gap: 16px;
`;

export const HeaderCard = styled.div`
  width: 100%;
  height: 74px;
  background: var(--cco-surface);
  border-radius: 12px;
  border: 1px solid var(--cco-line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: var(--cco-ink);
`;

export const SubTitle = styled.span`
  color: var(--cco-ink-faint);
  font-size: 13px;
  font-weight: 600;
`;

export const FormCard = styled.div`
  width: 100%;
  background: var(--cco-surface);
  border-radius: 12px;
  border: 1px solid var(--cco-line);
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 700;
  color: var(--cco-ink);
`;

// Input nativo no design CCO: superficie suave, borda hairline, foco azul.
export const FormInput = styled.input`
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--cco-line);
  background: var(--cco-soft-surface);
  color: var(--cco-ink);
  font-size: 13px;
  font-weight: 600;
  outline: none;
  transition: border-color 150ms, box-shadow 150ms;
  box-sizing: border-box;

  &::placeholder {
    color: var(--cco-ink-faint);
  }

  &:focus {
    border-color: var(--cco-blue);
    box-shadow: 0 0 0 2px var(--cco-blue-soft);
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$center ? 'center' : 'flex-end')};
  gap: 10px;
`;

// CTA principal do modal — pill azul.
export const ModalSaveButton = styled.button`
  height: 46px;
  padding: 0 56px;
  border-radius: 10px;
  border: none;
  background: var(--cco-blue);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: filter 150ms;
  font-family: inherit;

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const SecondaryButton = styled.button`
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid var(--cco-line);
  background: transparent;
  color: var(--cco-ink-mute);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 150ms, color 150ms;

  &:hover {
    border-color: var(--cco-line-strong);
    color: var(--cco-ink);
  }
`;

export const PrimaryButton = styled.button`
  height: 40px;
  padding: 0 22px;
  border-radius: 10px;
  border: none;
  background: var(--cco-blue);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  cursor: pointer;
  font-family: inherit;
  transition: filter 150ms;

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
